import React from 'react'

import styled from 'styled-components'

import TikTok from 'src/Assets/Svg/platform-icons/TikTok.svg?react'
import Spotify from 'src/Assets/Svg/platform-icons/Spotify.svg?react'
import {
  SquareButton,
  SquareButtonProps,
} from 'src/Components/Buttons/SquareButton'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'

const StyledButton = styled(SquareButton)`
  padding: 0 12px;

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    padding: 7px;
    span {
      display: none;
    }
  }
`

const ChildrenWrapper = styled.div`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  display: flex;
  gap: 8px;

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    span {
      display: none;
    }
  }
`

export type UpsellButtonProps = Pick<
  SquareButtonProps,
  'loading' | 'onClick' | 'disabled' | 'className'
> & {
  platform: CampaignPlatformTypeEnum
}

export const UpsellButton: React.FC<UpsellButtonProps> = ({
  loading,
  className,
  onClick,
  disabled,
  platform,
}) => {
  const PlatformIcon =
    platform === CampaignPlatformTypeEnum.TIKTOK ? TikTok : Spotify

  const buttonText =
    platform === CampaignPlatformTypeEnum.TIKTOK
      ? 'Create TikTok campaign'
      : 'Create Spotify campaign'

  return (
    <StyledButton
      className={className}
      loading={loading}
      disabled={disabled}
      onClick={onClick}
    >
      <ChildrenWrapper>
        {/* eslint-disable-next-line react/jsx-no-useless-fragment */}
        <>
          <PlatformIcon />
        </>

        <span>{buttonText}</span>
      </ChildrenWrapper>
    </StyledButton>
  )
}
